import Vue from "vue";
//import WeVue from 'we-vue'
import router from "./router";
//import 'we-vue/lib/style.css'
import App from "./App.vue";
import axios from "axios";
//import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAxios from "vue-axios";
import "lib-flexible"; // 移动端适配 (目录: hello-world/src/main.js)
Vue.use(VueAxios, axios);
//Vue.use(WeVue)
import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);
Vue.use(ElementUI);

//全局loading挂载
import loadingIndex from "./utils/loading";
Vue.use(loadingIndex);
// import './promission.js';
// Vue.use(VueRouter)
Vue.config.productionTip = false;
// Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_API;
Vue.prototype.$baseUrl = 'https://kcdh.sdei.edu.cn/dashuserver/';


//axios.defaults.baseURL = process.env.VUE_APP_BASE_API
new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
}).$mount("#app");
